<script setup>
import { useForm } from '@inertiajs/vue3';
import { useModal } from '@/composables/useModal.js';
import AppButton from '@/components/AppButton.vue';
import Modal from '@/components/Modal.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormCheckbox from '@/components/Forms/FormCheckbox.vue';

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    questionsTotal: {
        type: Number,
        required: true,
    },
});

const form = useForm({
    column: null,
    replace_from: null,
    replace_to: null,
    confirmation: false,
});

const submit = () => {
    form.patch(props.url, {
        preserveScroll: true,
        onSuccess: () => {
            dismiss();
        },
    });
};

defineOptions({
    name: 'QuestionsMassReplaceModal',
});

const { isOpen, dismiss } = useModal(false);
</script>

<template>
    <div>
        <AppButton element="button" type="button" @click="isOpen = true">
            {{ $t('messages.questions_mass_replace') }}
        </AppButton>
        <Modal :show="isOpen" @close="dismiss">
            <div>
                {{ $t('messages.questions_mass_replace_description', { count: questionsTotal }) }}
            </div>

            <form action="" @submit.prevent="submit" class="mt-3">
                <div>
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.replace_where')" for="column" />
                        <FormSelect
                            id="column"
                            required
                            v-model="form.column"
                            :options="[
                                { text: $t('messages.title'), value: 'title' },
                                { text: $t('messages.description'), value: 'description' },
                            ]"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.column" class="mt-2" />
                    </div>
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.replace_from')" for="replace_from" />
                        <FormInput
                            required
                            id="replace_from"
                            v-model="form.replace_from"
                            name="replace_from"
                            type="text"
                            class="mt-1"
                        />
                        <FormError :value="form.errors.replace_from" class="mt-2" />
                    </div>
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.replace_to')" for="replace_to" />
                        <FormInput
                            required
                            id="replace_to"
                            v-model="form.replace_to"
                            name="replace_to"
                            type="text"
                            class="mt-1"
                        />
                        <FormError :value="form.errors.replace_to" class="mt-2" />
                    </div>
                    <div class="mt-1">
                        <FormCheckbox v-model="form.confirmation">
                            {{ $t('messages.replace_confirmation') }}
                        </FormCheckbox>
                        <FormError :value="form.errors.confirmation" class="mt-2" />
                    </div>
                </div>
                <div class="flex justify-end mt-5">
                    <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                </div>
            </form>
        </Modal>
    </div>
</template>
